var _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPercent = function SvgIconPercent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .314h16.627V16.94H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#616A88",
    d: "M8.314 1.49C4.204 1.49.862 4.832.862 8.94c0 4.11 3.343 7.452 7.452 7.452s7.451-3.342 7.451-7.451S12.423 1.49 8.314 1.49m0 15.608c-4.498 0-8.157-3.66-8.157-8.157S3.817.784 8.314.784s8.157 3.66 8.157 8.157-3.66 8.157-8.157 8.157"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .314)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#616A88",
    d: "M8.314 1.333c-4.022 0-7.295 3.272-7.295 7.294 0 4.023 3.273 7.295 7.295 7.295s7.294-3.272 7.294-7.295c0-4.022-3.272-7.294-7.294-7.294m0 14.903c-4.196 0-7.609-3.413-7.609-7.609 0-4.195 3.413-7.608 7.609-7.608 4.195 0 7.608 3.413 7.608 7.608 0 4.196-3.413 7.609-7.608 7.609m0-15.609c-4.411 0-8 3.59-8 8 0 4.412 3.589 8 8 8 4.41 0 8-3.588 8-8 0-4.41-3.59-8-8-8m0 16.314C3.73 16.94 0 13.21 0 8.627S3.73.313 8.314.313s8.313 3.73 8.313 8.314c0 4.585-3.73 8.314-8.313 8.314",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#616A88",
    d: "M5.972 5.53A1.07 1.07 0 0 0 4.903 6.6 1.07 1.07 0 1 0 5.972 5.53m0 2.842A1.776 1.776 0 0 1 4.198 6.6c0-.978.796-1.774 1.774-1.774s1.774.796 1.774 1.774-.796 1.774-1.774 1.774"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#616A88",
    d: "M5.972 5.688a.913.913 0 0 0 0 1.823.913.913 0 0 0 0-1.823m0 2.137a1.227 1.227 0 0 1 0-2.45c.676 0 1.225.549 1.225 1.224 0 .676-.55 1.226-1.225 1.226m0-2.843a1.62 1.62 0 0 0-1.617 1.617c0 .892.725 1.617 1.617 1.617.891 0 1.617-.725 1.617-1.617a1.62 1.62 0 0 0-1.617-1.617m0 3.548a1.933 1.933 0 0 1-1.93-1.93c0-1.065.866-1.932 1.93-1.932s1.93.867 1.93 1.931c0 1.065-.866 1.931-1.93 1.931M10.656 10.215a1.07 1.07 0 0 0 0 2.137 1.07 1.07 0 0 0 0-2.137m0 2.842a1.776 1.776 0 0 1-1.774-1.774c0-.978.795-1.773 1.774-1.773.978 0 1.773.795 1.773 1.773 0 .979-.795 1.774-1.773 1.774"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#616A88",
    d: "M10.656 10.372a.912.912 0 1 0 .002 1.824.912.912 0 0 0-.002-1.824m0 2.137a1.227 1.227 0 0 1 0-2.451c.675 0 1.225.55 1.225 1.225 0 .676-.55 1.226-1.225 1.226m0-2.843c-.892 0-1.617.726-1.617 1.617 0 .892.725 1.617 1.617 1.617.891 0 1.617-.725 1.617-1.617 0-.891-.726-1.617-1.617-1.617m0 3.548a1.933 1.933 0 0 1-1.931-1.93c0-1.065.866-1.931 1.93-1.931 1.065 0 1.931.866 1.931 1.93s-.866 1.931-1.93 1.931M5.298 12.455l-.498-.499 6.529-6.529.499.499z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#616A88",
    d: "M5.021 11.957l.277.276 6.308-6.307-.277-.277-6.308 6.308zm.277.72l-.72-.72 6.751-6.752.72.721-6.75 6.75z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPercent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-percent.4ebc7e12.svg";
export { ForwardRef as ReactComponent };